import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { DIALOG_TYPE } from '../../../../constants';
import { Button } from '../../../../ui';

type DeleteUnitModalProps = {
  deleteUnit: () => void;
  cancelEvent: () => void;
};

export const DeleteUnitModal = ({
  deleteUnit,
  cancelEvent,
}: DeleteUnitModalProps) => {
  return (
    <>
      <Typography variant='body2' sx={{ color: 'text.secondary', mb: 1.5 }}>
        Warning - By pressing the <b>Delete</b> button below, the selected unit
        and all branches underneath it will be permanently deleted.
      </Typography>
      <Typography variant='body2' sx={{ color: 'text.secondary', mb: 3 }}>
        To cancel this operation, press the <b>Cancel</b> button below
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1.5 }}>
        <Button onClick={cancelEvent} variant='secondary' label='Cancel' />
        <Button
          dialogType={DIALOG_TYPE.ERROR}
          onClick={deleteUnit}
          variant='primary'
          label='Delete'
        />
      </Box>
    </>
  );
};
